import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _businessTerm = { score: 'DOUBLE' };
var _searchBusinessTermRequest = {};
var _searchBusinessTermResponse = { results: '_businessTerm' };
function resolveWixFunnelTaxonomyV1BusinessTermServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/funnel-taxonomy-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/funnel-taxonomy-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/funnel-taxonomy-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/funnel-taxonomy-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/funnel-taxonomy-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Searches content categories according to provided criterion */
export function searchBusinessTerm(payload) {
    var _a = serializer(_searchBusinessTermRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchBusinessTermResponse, {
        _businessTerm: _businessTerm,
    }).fromJSON;
    function __searchBusinessTerm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.taxonomy.v1.business_term',
            method: 'GET',
            methodFqn: 'wix.funnel.taxonomy.v1.BusinessTermService.SearchBusinessTerm',
            url: resolveWixFunnelTaxonomyV1BusinessTermServiceUrl({
                protoPath: '/v1/business-term/search',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchBusinessTerm.fromReq = fromReq;
    return __searchBusinessTerm;
}
//# sourceMappingURL=http.impl.js.map